<template>
    <header class="header box-shadow main-header">
        <h1 class="main-title">外包招聘系统</h1>
        <div class="header-row">
            <div class="main-header-right pull-right">
                <div class="pull-right">
                    <thumbnail :width="36" mode="horizontal">
                        <span style="color: #666;" v-text="user.name"></span>
                    </thumbnail>
                    <div class="opt-area"><span class="divider">|</span><span @click="logout" class="opt-text">退出</span>
                    </div>
                </div>
            </div>
            <div class="main-header-left pull-left">
                <i :class="[folding ? 'el-icon-my-zhankaidaohanglan' : 'el-icon-my-shouqidaohanglan']"
                   @click="toggleFold(folding)"></i>
                <span class="ml-15 mr-5">选择项目：</span>
                <el-select v-model="projectId" @change="projectChange(projectId)">
                    <el-option v-for="(item, index) in project" :key="index" :label="item.text"
                               :value="parseInt(item.value)"></el-option>
                </el-select>
            </div>
            <div class="menu-inline-block" >
                <template v-if="showTopMenu > -1">
                    <el-menu mode="horizontal" :default-active="$route.fullPath" router>
                        <el-menu-item :index="topMenu.resumeDetail">简历详情</el-menu-item>
                        <el-menu-item :index="topMenu.evaluationResume">简历评价</el-menu-item>
                        <el-menu-item :index="topMenu.writtenPersonDetail" v-if="hasWritten">笔试安排</el-menu-item>
                        <el-menu-item :index="topMenu.singleArrangement">面试安排</el-menu-item>
                        <el-menu-item :index="topMenu.evaluation">面试评价</el-menu-item>
                        <el-menu-item :index="topMenu.salary" v-if="hasSalary">定薪评价</el-menu-item>
                    </el-menu>
                </template>
                <el-menu  v-if="showInterviewMenu" style="height:60px;min-width:250px" mode="horizontal" :default-active="$route.path" router>
                    <el-menu-item index="/interview/1">一面</el-menu-item>
                    <el-menu-item index="/interview/2">二面</el-menu-item>
                    <el-menu-item index="/interview/3">三面</el-menu-item>
                    <el-menu-item index="/interview/4">四面</el-menu-item>
                </el-menu>
            </div>
        </div>
    </header>
</template>
<script type="text/javascript">
    import Thumbnail from 'components/thumbnail'
    import switchProjectMixin from 'views/login/switchProjectMixin'

    export default {
        mixins: [switchProjectMixin],
        data () {
            return {
                projectId: '',
                changeCount: 1
            }
        },
        computed: {
            hasSalary () {
                return this.$store.state.user.paymentFlag
            },
            hasWritten () {
                return this.$store.state.user.writtenFlag
            },
            folding () {
                return this.$store.state.folding
            },
            user () {
                this.projectId = this.$store.state.user.projectId
                return this.$store.state.user
            },
            project () {
                return this.$store.state.app.project
            },
            showTopMenu () {
                return ['resumeDetail', 'singleArrangement', 'writtenPersonDetail', 'evaluationResume', 'evaluation', 'paymentDetail'].indexOf(this.$route.name)
            },
            showInterviewMenu () {
                return this.$route.name === 'interviewList'
            },
            topMenu () {
                let index = this.$route.fullPath.indexOf(this.$route.path),
                    query = this.$route.fullPath.substr(index + this.$route.path.length)
                let menuMap = {
                    resumeDetail: `/resume/detail/${this.$route.params.id}/0${query}`,
                    singleArrangement: `/arrangement/${this.$route.params.id}${query}`,
                    evaluation: `/evaluation/${this.$route.params.id}${query}`,
                    evaluationResume: `/evaluationResume/${this.$route.params.id}${query}`,
                    salary: `/salary/detail/${this.$route.params.id}${query}`,
                    writtenPersonDetail: `/written/detail/${this.$route.params.id}${query}`
                }
                menuMap[this.$route.name] = this.$route.fullPath
                return menuMap
            }
        },
        methods: {
            logout () {
                this.$axios.get('/logout.api', {
                    'X-loadingOff': true
                }).then(res => {
                    this.$store.commit('USER_SIGN_OUT')
                    this.$router.replace({name: 'login'})
                }).catch(() => {
                })
            },

            toggleFold (boolean) {
                this.$store.commit('FOLDING', !boolean)
            },

            projectChange (projectId) {
                if (this.changeCount >= 1 && Object.keys(this.user).length) {  // 点退出，避免跑里面
                    this.$axios.post('/loginProject.api', {projectId: projectId}).then(res => {
                        this.successLogin(res, true)
                    }).catch(() => {
                    })
                }
                this.changeCount++
            }
        },
        components: {
            Thumbnail
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
    @import "~style/base/mixin";

    .main-header {
        .main-title {
            @include transition;
            float       : left;
            width       : $main-menu-width;
            text-indent : -99999px;
            height      : $main-header-height;
            background  : $color-primary url('~images/logo-text.png') no-repeat center;
        }
        .header-row {
            height      : $main-header-height;
            line-height : $main-header-height;;
        }
        &-left {
            padding-left : 30px;
            width        : 350px;
            > i {
                cursor    : pointer;
                font-size : 20px;
                color     : $color-icon;
            }
            span {
                color : $text-color-third;
            }
        }
        &-right {
            padding-right : 30px;
            // width         : 350px;
            .opt-area {
                display        : inline-block;
                vertical-align : middle;
            }
            .opt-text {
                color  : $color-primary;
                cursor : pointer;
            }
            .divider {
                color  : $text-color-third;
                margin : 0 10px;
            }
        }
        .menu-inline-block {
            text-align : center;
            > .el-menu {
                display          : inline-block;
                background-color : transparent;
                > .el-menu-item {
                    border-bottom-width : 3px;
                    margin              : 0 5px;
                    padding             : 0 10px;
                    &.is-active {
                        border-bottom    : 3px solid $color-primary;
                        background-color : transparent;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1400px){
        .main-header .menu-inline-block > .el-menu > .el-menu-item{
            padding: 0 5px;
            font-size: 12px;
        }
    }
    @media screen and (max-width: 1200px){
        .main-header .menu-inline-block > .el-menu > .el-menu-item{
            padding: 0;
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// header.vue?b0113e62